import React, { useEffect, useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Swal from 'sweetalert2';
import { generateAxiosInstance } from '../hooks/useAuthorizedRequest';
import { generateAxiosInstanceCommon } from '../hooks/useAuthorizedReuestCommon';
import ViewImageAndText from '../components/ViewImageAndText';
import VidyaUpasnaLogo from '../assets/VidyaUpasna.jpg';
import { CModal } from '@coreui/react';
import { useNavigate } from 'react-router-dom';
import Pagination from '../components/Pagination';
import { findIndexById, findPageNumber, deleteItem, SortIcon, searchArray } from '../components/Navigation';
import { Loader } from '../components/ModalsCommonFunctions';
import ViewImageAndTextQuetionBank from '../components/ViewImageAndTextQuetionBank';

const ViewTextBook = () => {
    const authorizedAxios = generateAxiosInstance();
    const authorizedAxiosCommon = generateAxiosInstanceCommon();
    const [questions, setQuestion] = useState("");
    const [editId, setEditId] = useState(null);
    const [syllabusList, setSyllabusList] = useState([]);
    const [subjectList, setSubjectList] = useState([])
    const [topicList, setTopicList] = useState([])
    const [lessonList, setLessonList] = useState([])
    const [subTopicViewtopicList, setSubTopicViewtopicList] = useState([])
    const [visible, setVisible] = useState(false)
    const [modalData, setModalData] = useState("")

    const initialFormState = {
        q_level: '',
        q_type: '',
        question: '',
        option_a: '',
        option_b: '',
        option_c: '',
        option_d: '',
        ans: '',
        sol: ''
    }

    const initialFilterState = {
        syllabusStructureMasterId: '',
        lessonMasterId: '',
        topicMasterId: '',
        subTopicId: '',
        subTopicName: '',
        subjectMasterId: ''
    }

    const [filter, setFilter] = useState(initialFilterState);
    const [editAns, setEditAns] = useState(initialFormState);
    const [visibleImage, setVisibleImage] = useState(false);
    const [modalImageSrc, setModalImageSrc] = useState('');

    const [startIndex, setStartIndex] = useState(null);
    const [currPage, setCurrPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [displayedData, setDisplayedData] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [saveId, setSaveId] = useState(null);
    const [refresh, setRefresh] = useState(true);
    const [addNew, setAddNew] = useState(false);

    const [searchValue, setSearchValue] = useState(null);
    const searchKeys = ["question", "option_a", "option_b", "option_c", "option_d", "ans", "sol"];

    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const handleNavigate = (route) => {
        navigate(route);
    };

    const onViewImage = (imgSrc) => {
        setModalImageSrc(imgSrc);
        setVisibleImage(true);
    };

    useEffect(() => {
        getSyllabusList();
    }, []);

    useEffect(() => {
        if (searchValue === '' && searchValue !== null) {
            setCurrPage(1);
            setRefresh(!refresh);
        }
    }, [searchValue]);


    const handleEmptySearch = (e) => {
        setSearchValue(e.target.value);
    }

    const handleSearch = async () => {
        if (searchValue !== null) {
            if (filter.syllabusStructureMasterId !== "" && filter.subjectMasterId !== "") {
                let apiUrl = `/get-question-bank?`;

                if (filter.syllabusStructureMasterId) {
                    apiUrl += `syllabusStructureMasterId=${filter.syllabusStructureMasterId}&`;
                }
                if (filter.subjectMasterId) {
                    apiUrl += `subjectMasterId=${filter.subjectMasterId}&`
                }
                if (filter.lessonMasterId) {
                    apiUrl += `lessonMasterId=${filter.lessonMasterId}&`;
                }
                if (filter.topicMasterId) {
                    apiUrl += `topicMasterId=${filter.topicMasterId}&`;
                }
                if (filter.subTopicId) {
                    apiUrl += `subTopicMasterId=${filter.subTopicId}&`;
                }

                apiUrl = apiUrl.replace(/&$/, '');
                setQuestion(await searchArray("A", apiUrl, searchKeys, searchValue.trim(), "data"))
            }
        }
    }

    useEffect(() => {
        if (filter.syllabusStructureMasterId !== "" && filter.subjectMasterId !== "") {
            getQuestionAnswerList();
        }
    }, [filter, refresh]);

    useEffect(() => {
        if (saveId) {
            const pageNumber = findPageNumber(questions, saveId, itemsPerPage);
            setCurrPage(pageNumber);
        }
    }, [saveId, addNew])

    useEffect(() => {
        setTotalPages(Math.ceil(questions.length / itemsPerPage));
        const startIndex = (currPage - 1) * itemsPerPage;
        let endIndex = startIndex + itemsPerPage;

        if (endIndex > questions.length) {
            endIndex = questions.length;
        }
        setStartIndex(startIndex);
        setDisplayedData(questions.slice(startIndex, endIndex));
    }, [questions, currPage, itemsPerPage]);

    const getQuestionAnswerList = () => {
        if (filter.syllabusStructureMasterId !== "" && filter.subjectMasterId !== "") {
            let apiUrl = getApiUrl();

            authorizedAxios && authorizedAxios.get(apiUrl)
                .then(response => {
                    setQuestion(response.data.data)
                    // console.log(response.data.data);
                })
                .catch(error => {
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    console.error('Error fetching data:', errorMsg);
                });
        }
    }

    const getApiUrl = () => {
        if (filter.syllabusStructureMasterId !== "" && filter.subjectMasterId !== "") {
            let apiUrl = `/get-question-bank?`;

            if (filter.syllabusStructureMasterId) {
                apiUrl += `syllabusStructureMasterId=${filter.syllabusStructureMasterId}&`;
            }
            if (filter.subjectMasterId) {
                apiUrl += `subjectMasterId=${filter.subjectMasterId}&`
            }
            if (filter.lessonMasterId) {
                apiUrl += `lessonMasterId=${filter.lessonMasterId}&`;
            }
            if (filter.topicMasterId) {
                apiUrl += `topicMasterId=${filter.topicMasterId}&`;
            }
            if (filter.subTopicId) {
                apiUrl += `subTopicMasterId=${filter.subTopicId}&`;
            }

            apiUrl = apiUrl.replace(/&$/, '');
            return apiUrl;
        }
    }

    const getList = () => {
        if (filter.syllabusStructureMasterId !== "" && filter.subjectMasterId !== "") {
            let apiUrl = getApiUrl();

            authorizedAxios && authorizedAxios.get(apiUrl)
                .then(response => {
                    setQuestion(response.data.data)
                    setAddNew(!addNew);
                    // console.log(response.data.data);
                })
                .catch(error => {
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    console.error('Error fetching data:', errorMsg);
                });
        }
    }

    const getSyllabusList = () => {
        const apiUrlForSyllabus = `/get-all-syllabus-structure`;
        authorizedAxiosCommon && authorizedAxiosCommon.get(apiUrlForSyllabus)
            .then(response => {
                setSyllabusList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleSyllabusChange = (e) => {
        setFilter((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
                lessonMasterId: '',
                topicMasterId: '',
                subTopicId: '',
                subjectMasterId: ''
            }
        })
        setLessonList([])

        const apiUrl2 = `/syllabus-structure-wise-subjects?id=${e.target.value}`;
        authorizedAxios && authorizedAxios.get(apiUrl2)
            .then(response => {
                setSubjectList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleSubjectChange = (e) => {
        setFilter((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
                lessonMasterId: '',
                topicMasterId: '',
                subTopicId: '',
            }
        })
        const apiUrl = `/subject-wise-lesson?syllabusStructureMasterId=${filter.syllabusStructureMasterId}&subjectMasterId=${e.target.value}`;
        authorizedAxios && authorizedAxios.get(apiUrl)
            .then(response => {
                setLessonList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleLessonChange = (e) => {
        setFilter((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
                topicMasterId: '',
                subTopicId: ''
            }
        })
        const apiUrl = `/lesson-wise-topic?id=${e.target.value}`;
        authorizedAxios && authorizedAxios.get(apiUrl)
            .then(response => {
                setTopicList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleTopicChange = (e) => {
        setFilter((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
                subTopicId: ''
            }
        })
        const apiUrl = `/get-sub-topic-master-list?syllabusStructureId=${filter.syllabusStructureMasterId}&subjectMasterId=${filter.subjectMasterId}&lessonId=${filter.lessonMasterId}&topicId=${e.target.value}`;
        authorizedAxios && authorizedAxios.get(apiUrl)
            .then(response => {
                setSubTopicViewtopicList(response.data.result)
            })
            .catch(error => {
                console.error('Error fetching data:', error);
                setSubTopicViewtopicList([])
            });
    }

    const handleInputChangeFilter = (e) => {
        setFilter((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value
            }
        })
    }


    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <div id='scroll-up'></div>
                <Header />
                <div className="container-fluid">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb my-0 ms-2">
                            <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/dashboard')}>
                                <span>Dashboard</span>
                            </li>
                            <li className="breadcrumb-item active"><span>View Text Book Question Bank</span></li>
                        </ol>
                    </nav>
                </div>

                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fa fa-eye"></i>View Text Book Question Bank</b></h4>
                                </div>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label">Select Syllabus Structure :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='syllabusStructureMasterId' onChange={handleSyllabusChange} value={filter.syllabusStructureMasterId}>
                                                        <option selected value={''}>Select Syllabus</option>
                                                        {
                                                            syllabusList?.map((syllabus) => {
                                                                return <option value={syllabus.id}>{syllabus?.syllabusStructureName}</option>
                                                            })
                                                        }
                                                    </select>
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label">Select Subject :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='subjectMasterId' onChange={handleSubjectChange} value={filter.subjectMasterId}>
                                                        <option selected value={''} disabled>Select Subject</option>
                                                        {
                                                            subjectList?.map((syllabus) => {
                                                                return <option value={syllabus.subjectMasterDetails.id}>{syllabus.subjectMasterDetails.subjectName}</option>
                                                            })
                                                        }
                                                    </select>
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label">Select Lesson :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='lessonMasterId' onChange={handleLessonChange} value={filter.lessonMasterId}>
                                                        <option selected value={''} disabled>Select Lesson</option>
                                                        {
                                                            lessonList?.map((lesson) => {
                                                                return <option value={lesson.id}>{lesson.lessonName}</option>
                                                            })
                                                        }
                                                    </select>
                                                </div>
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label">Select Topic :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='topicMasterId' onChange={handleTopicChange} value={filter.topicMasterId}>
                                                        <option selected value={''} disabled>Select Topic</option>
                                                        {
                                                            topicList?.map((topic) => {
                                                                return <option value={topic.id}>{topic.topicName}</option>
                                                            })
                                                        }
                                                    </select>
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label">Select Sub Topic :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='subTopicId' onChange={handleInputChangeFilter} value={filter.subTopicId}>
                                                        <option selected value={''} disabled>Select Sub Topic</option>
                                                        {
                                                            subTopicViewtopicList?.map((topic) => {
                                                                return <option value={topic.id}>{topic.subTopicName}</option>
                                                            })
                                                        }
                                                    </select>
                                                </div>

                                                {!editId && <div className="col-md-12 mt-3 mb-1" style={{ textAlign: 'center' }}>
                                                    <div className="col-auto">
                                                        <button className="btn btn-outline-danger delete_icon" type="button" style={{ marginRight: '20px' }} onClick={() => { setFilter(initialFilterState) }}>Reset</button>
                                                    </div>
                                                </div>}


                                                {/* {editAns.question !== '' && <>
                                                    <div className='row'>
                                                        <div className="col-md-6">
                                                            <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Question Level :</label>
                                                            <input required type="text" className="form-control" id="q_level" name='q_level' onChange={handleInputChange} value={editAns.q_level} />
                                                        </div>
                                                        <div className="col-md-6">
                                                            <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Question Type :</label>
                                                            <input required type="text" className="form-control" id="q_type" name='q_type' onChange={handleInputChange} value={editAns.q_type} />
                                                        </div>
                                                    </div>

                                                    <div className='row'>
                                                        <div className="col-md-12">
                                                            <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Question :</label>
                                                            <input required type="text" className="form-control" id="question" name='question' onChange={handleInputChange} value={editAns.question} />
                                                        </div>
                                                    </div>

                                                    <div className='row'>
                                                        <div className="col-md-6">
                                                            <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Option A :</label>
                                                            <input required type="text" className="form-control" id="option_a" name='option_a' onChange={handleInputChange} value={editAns.option_a} />
                                                        </div>
                                                        <div className="col-md-6">
                                                            <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Option B :</label>
                                                            <input required type="text" className="form-control" id="option_b" name='option_b' onChange={handleInputChange} value={editAns.option_b} />
                                                        </div>
                                                        <div className="col-md-6">
                                                            <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Option C :</label>
                                                            <input required type="text" className="form-control" id="option_c" name='option_c' onChange={handleInputChange} value={editAns.option_c} />
                                                        </div>
                                                        <div className="col-md-6">
                                                            <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Option D :</label>
                                                            <input required type="text" className="form-control" id="option_d" name='option_d' onChange={handleInputChange} value={editAns.option_d} />
                                                        </div>
                                                        <div className='row'>
                                                            <div className="col-md-12">
                                                                <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Answer :</label>
                                                                <input required type="text" className="form-control" id="sol" name='ans' onChange={handleInputChange} value={editAns.ans} />
                                                            </div>
                                                            <div className="col-md-12">
                                                                <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Solution :</label>
                                                                <input required type="text" className="form-control" id="sol" name='sol' onChange={handleInputChange} value={editAns.sol} />
                                                            </div>
                                                        </div>
                                                    </div>


                                                    <div className="col-md-12 mt-3 mb-1" style={{ textAlign: 'center' }}>

                                                        <div className="col-auto">
                                                            <button className="btn btn-primary" type="button" style={{ marginRight: '20px' }} onClick={() => updateSubtopic()} >Update</button>
                                                            <button className="btn btn-outline-danger delete_icon" type="button" style={{ marginRight: '20px' }} onClick={() => { setEditAns(initialFormState); setEditId(null) }}>Reset</button>
                                                        </div>
                                                    </div>
                                                </>} */}



                                                {filter.subjectMasterId !== "" &&

                                                    <div className='row'>
                                                        <div className="separator"></div>

                                                        <div className="d-grid gap-2 mt-2">
                                                            {displayedData.length > 0 ?
                                                                <>
                                                                    <div className='search_btn_row'>
                                                                        <input
                                                                            className="form-control mr-sm-2"
                                                                            type="Search"
                                                                            placeholder="Search"
                                                                            value={searchValue}
                                                                            onChange={handleEmptySearch}
                                                                            onKeyDown={(event) => {
                                                                                if (event.key === 'Enter') {
                                                                                    handleSearch();
                                                                                }
                                                                            }}
                                                                        />
                                                                        <button className="btn btn-outline-primary" onClick={handleSearch}><i class="fa fa-search" aria-hidden="true"></i></button>
                                                                    </div>
                                                                    <div class="generate_pdf_question_paper_report_block" id="examReportContent">
                                                                        <div class="generate_pdf_question_paper_heading">
                                                                            <div class="generate_pdf_question_paper_logo">
                                                                                {/* <img src={displayedData[0]?.instituteMasterDetails?.logoPath} alt="Institute Logo" /> */}
                                                                                <img src={VidyaUpasnaLogo} alt="VidyaUpasna Logo" />
                                                                            </div>
                                                                            <div class="text_center">
                                                                                {/* <h6>{displayedData[0]?.instituteMasterDetails?.instituteName}</h6> */}
                                                                                {/* <h4>{displayedData[0]?.sectionMasterDetails?.sectionName}</h4> */}
                                                                                <h4>VidyaUpasna</h4>
                                                                            </div>
                                                                            <div class="generate_pdf_question_paper_logo">
                                                                                {/* <img src={displayedData[0]?.instituteMasterDetails?.logoPath} alt="Institute Logo" /> */}
                                                                                <img src={VidyaUpasnaLogo} alt="VidyaUpasna Logo" />
                                                                            </div>
                                                                        </div>

                                                                        <div class="generate_pdf_question_paper_report_code">
                                                                            <span class="line"></span>
                                                                        </div>

                                                                        <div class="generate_pdf_question_paper_details">
                                                                            <span>Syllabus: {displayedData[0]?.syllabusStructureMasterDetails?.syllabusStructureName}</span>
                                                                            <span>Subject: {displayedData[0]?.subjectMasterDetails?.subjectName}</span>
                                                                            {/* <span>Lesson: {pdfDetails?.examTotalMarks}</span> */}
                                                                        </div>


                                                                        <ol className="generate_pdf_question_paper_generated_pdf_total_question">
                                                                            {displayedData?.map((question, index) => {
                                                                                return (
                                                                                    <>
                                                                                        {index == 0 && <div class="generate_pdf_question_paper_details">
                                                                                            <span>Lesson: {question?.lessonMasterDetails?.lessonName}</span>
                                                                                        </div>}
                                                                                        {index !== 0 && (displayedData[index - 1].lessonMasterId !== question.lessonMasterId) && <div class="generate_pdf_question_paper_details">
                                                                                            <span>Lesson: {question?.lessonMasterDetails?.lessonName}</span>
                                                                                        </div>}
                                                                                        <li key={index} className="generate_pdf_question_paper_question pdf-question-paper-listed-outer">
                                                                                            {/* <p>{question.question}</p> */}
                                                                                            {/* <p> */}
                                                                                            {/* <strong>{startIndex + index + 1}. </strong> */}
                                                                                            {/* <ViewImageAndTextQuetionBank inputString={question.question} onViewImage={onViewImage} /> */}
                                                                                            {/* </p> */}

                                                                                            <div className='card-question-header'>
                                                                                                <span className="list-number">{startIndex + index + 1}.</span>
                                                                                                <ViewImageAndTextQuetionBank inputString={question.question} onViewImage={onViewImage} />
                                                                                            </div>
                                                                                            <ul className='margin-top-10'>
                                                                                                {['option_a', 'option_b', 'option_c', 'option_d'].map((optionKey, optionIndex) => {
                                                                                                    const optionLetter = String.fromCharCode(65 + optionIndex); // A, B, C, D
                                                                                                    // const isCorrect = question.ans.split(',').includes(String.fromCharCode(97 + optionIndex)); // Checking if the answer matches
                                                                                                    return (
                                                                                                        <li key={optionIndex} data-option={optionLetter} /*className={isCorrect ? "correct" : ""}*/>
                                                                                                            {/* {question[optionKey]} */}
                                                                                                            <ViewImageAndTextQuetionBank inputString={question[optionKey]} onViewImage={onViewImage} />
                                                                                                        </li>
                                                                                                    );
                                                                                                })}
                                                                                            </ul>
                                                                                            <p className="pdf-highlight"><strong>Correct Answer:</strong> {question.ans.toUpperCase()}</p>
                                                                                            <p className="pdf-highlight"><strong>Solution:</strong><ViewImageAndTextQuetionBank inputString={question.sol} onViewImage={onViewImage} /></p>
                                                                                        </li>
                                                                                    </>
                                                                                )
                                                                            })}
                                                                        </ol>

                                                                    </div>
                                                                    <Pagination currPage={currPage} setCurrPage={setCurrPage} totalPages={totalPages} itemsPerPage={itemsPerPage} setItemsPerPage={setItemsPerPage} totalItem={questions.length} />
                                                                </>
                                                                :
                                                                (<div className='row'>
                                                                    <th colspan={"100%"} style={{ textAlign: 'center' }}>No Questions Available</th>
                                                                </div>)}
                                                        </div>
                                                    </div>

                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />

            {visible && <CModal
                visible={visible}
                onClose={() => setVisible(false)}
                aria-labelledby="LiveDemoExampleLabel"
                onIni
            >
                <div className="book book-modal">
                    <h2 className='table-header-like'> Solution</h2>
                    <div className="page no-error-class" dangerouslySetInnerHTML={{
                        __html: `<style>.ckContent img{max-width:100% !important; height: auto !important}</style><div class="ck-content">${modalData === null ? "No Solution Found" : modalData}</div>`
                    }}></div>

                    <button className="btn btn-outline-warning edit_icon" type="button" onClick={() => setVisible(false)}>
                        Close
                    </button>
                </div>
            </CModal>}

            {visibleImage && (
                <CModal
                    visible={visibleImage}
                    onClose={() => setVisibleImage(false)}
                    aria-labelledby="LiveDemoExampleLabel"
                >
                    <div className="book book-modal">
                        <div className='table-header-like'>Image</div>
                        {modalImageSrc && <div className='page' dangerouslySetInnerHTML={{ __html: modalImageSrc }}></div>}
                        <button className="btn btn-outline-warning edit_icon" type="button" onClick={() => setVisibleImage(false)}>
                            Close
                        </button>
                    </div>
                </CModal>
            )}
        </>
    )
};

export default ViewTextBook;
